import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTableauViz } from '../../hooks/useTableauViz.js';
import NoDataComponent from '../../../dashboard_gen2/no_data_component.jsx';
import LoadingIndicator from '../../../common/loading_indicator.jsx';

// TODO: Previously and now still have resize problem because the iframe is width and length is set on load
function TableauWidget({ widgetId }) {
    const embedded_url = useSelector(state => state.dashboard.widgets[widgetId].settings?.embedded_url);
    const {isLoaded} = useTableauViz();
    const tableRef = useRef();
    // const layout = useSelector(state => state.dashboard.layout[widgetId]);

    useEffect(() => {
        if (isLoaded && embedded_url && embedded_url !== '' && tableRef.current){
            tableRef.current.setAttribute('src', embedded_url);
            tableRef.current.setAttribute('toolbar', 'hidden');
        }
    }, [isLoaded, embedded_url])

    // Tried to resize on layout change but somehow viz isn't initialized even though it already showing content?
    // useEffect(() => {
    //     if (tableRef.current) tableRef.current.resize();
    // }, [layout])

    return (
        (embedded_url === '' || !embedded_url) ? 
        <NoDataComponent /> 
        :
        (isLoaded ?  
            <tableau-viz ref={tableRef} />
            :
            <LoadingIndicator />
        )
    )
}

export default TableauWidget;
